import { useTranslation } from "react-i18next";
import "./ContactUs.css";

function ContactUs({ data, sectionTitle }) {
  const { t } = useTranslation();

  return (
    <div className="tkdn-container-definition">
      <div className="tkdn-section-header">
        <div className="border-title-vpti" />
        <h1 className="tkdn-section-title">{t(sectionTitle)}</h1>
      </div>
      <div className="tkdn-contact-us">
        {data.map((item, i) => (
          <div>
            <h2 className="tkdn-subtitle" style={{ fontSize: "14px" }}>
              {item.name}
            </h2>
            <i
              class="fas fa-envelope"
              style={{ color: "black", marginRight: "10px" }}
            />{" "}
            <a
              href={"mailto:" + item.email}
              style={{ fontWeight: "300", fontSize: "14px" }}
            >
              {item.email}
              <br />
            </a>
            {item.phone !== "" ? (
              <>
                <i
                  class="fas fa-phone-alt"
                  style={{ color: "black", marginRight: "10px" }}
                />
                <a
                  href={"tel:" + item.phone}
                  style={{ fontWeight: "300", fontSize: "14px" }}
                >
                  {" "}
                  {item.phone} <br />
                </a>
              </>
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContactUs;
